import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Exam Rules</h1>
                <p>Home &gt;  Exam Rules</p>
            </div>
        </div>
    )
}

export default Hero;